<template>
  <div class="page-head">
    <!-- logo -->
    <div class="logo-container">
      <img src="../../assets/images/logo.png" @click="toHome">
    </div>
    <div class="menu-container">
      <Menu :menuList="menuList"></Menu>
    </div>

    <!-- 个性化设置 -->
    <div class="personalization" @click="parentOpenSetHomePage">
      <img class="tools" src="../../assets/images/menu/tools.png">
      <span>个性化设置</span>
    </div>

    <!-- 数据中心 -->
    <div class="date-main">
      <el-dropdown @command="handleDateCenterCommand">
        <span class="el-dropdown-link">
          <img class="laptop-img" src="../../assets/images/menu/laptop.png">
        </span>
        <el-dropdown-menu slot="dropdown" class="data-dropdown-menu">
          <el-dropdown-item command="dataDownload">数据下载</el-dropdown-item>
          <el-dropdown-item command="abnormal">异常订单</el-dropdown-item>
          <el-dropdown-item command="orderUplode">订单导入</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 名称 -->
    <div class="user-container">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <img class="user-img" src="../../assets/images/menu/user.png">
          <span class="name">{{ userName }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
          <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
      
    <!-- 异常订单 -->
    <AbnormalOrder
      :warehouseList="warehouseList" 
      :abnormalDrawer="abnormalDrawer"
      :abnormalParentActiveName="abnormalParentActiveName"
      @closeParentAbnormalDrawer="closeParentAbnormalDrawer"
      @handleParentAbnormalOrderDrawerTabsClick="handleParentAbnormalOrderDrawerTabsClick"
    ></AbnormalOrder>

    <!-- 数据下载 -->
    <DataDown 
      :dataDownLoadDrawer="dataDownLoadDrawer"
      @closeParentDataDownLoadDrawer="closeParentDataDownLoadDrawer"
    ></DataDown>

    <!-- 订单导入 -->
    <OrderUpload 
      :drawer="drawer" 
      :warehouseList="warehouseList" 
      @closeParentDrawer="closeParentDrawer"
    ></OrderUpload>

    <!-- 个性化设置抽屉 -->
    <Personalization></Personalization>
  </div>
</template>

<script>
import Menu from 'components/layout/Menu.vue'
import warehouseMixins from "@/common/mixins/warehouse.js"
import Personalization from "components/base/head/Personalization";
import OrderUpload from "components/base/head/order-upload";
import AbnormalOrder from "components/base/head/abnormal-order";
import DataDown from "components/base/head/data-down";
import { getDBUserRealName } from "@/common/js/storage";
export default {
  mixins: [warehouseMixins],
  components: {
    Menu,
    DataDown,
    OrderUpload,
    AbnormalOrder,
    Personalization
  },
  props: {
    menuList: {
      type: Array,
    },
  },

  data() {
    return {
      userName: '',
      // 订单导入开关
      drawer: false,
      // 数据下载开关
      dataDownLoadDrawer: false,
      // 异常订单开关
      abnormalDrawer: false,
      // 异常订单Tab切换开关
      // mapping:未维护映射关系预警; commodityWeightAlertNotMaintained
      abnormalParentActiveName: 'mapping',
    }
  },

  created() {
    this.userName = getDBUserRealName()
    this.initWarehouse()
    this.$bus.on('openAbnormalDrawer', e => {
      this.openAbnormalDrawer()
      this.abnormalParentActiveName = e
    })
  },

  methods: {
    toHome() {
      this.$router.push('/home')
    },

    handleCommand(command) {
      if (command === 'loginOut') {
        this.$emit('loginOut')
      }
    },

    handleDateCenterCommand(command) {
      if (command === 'abnormal') {
        this.openAbnormalDrawer()
      } else if (command === 'orderUplode') {
        this.drawer = true
      } else if (command === 'dataDownload') {
        this.dataDownLoadDrawer = true
      }
    },

    /** 
     * @desc 开启异常订单
    */
    openAbnormalDrawer() {
      this.abnormalDrawer = true
    },

    /** 
     * @desc 关闭异常订单
    */
    closeParentAbnormalDrawer() {
      this.abnormalParentActiveName = 'mapping'
      this.abnormalDrawer = false
    },

    /** 
     * @desc 获取异常订单当前tabs的名称
    */
    handleParentAbnormalOrderDrawerTabsClick(name) {
      this.abnormalParentActiveName = name
    },

    /** 
     * @desc 关闭订单导入
    */
    closeParentDrawer() {
      this.drawer = false
    },

    /** 
     * @desc 关闭数据下载
    */
    closeParentDataDownLoadDrawer() {
      this.dataDownLoadDrawer = false
    },

    /** 
     * @desc 打开个性化设置
    */
    parentOpenSetHomePage() {
      this.$bus.emit('parentOpenSetHomePage')
    }
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/head/head.scss';
</style>
